import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, Label, Button, FormFeedback } from "reactstrap";
import APIS from '../../assets/API-Responce.png'
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Select from "react-select";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import { formatCurrency, formatDate } from '../../Utils/formatters';


const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserKYC = props => {
  //meta title
  document.title = "Users KYC";
  const { getRequest, postRequest } = useRequests();


  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};
  
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      user: {label: 'All', value: 'All'},
      status: 'All',
    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        let filteredData = UsersData;
        if(values.user.value !== 'All') {
          filteredData = filteredData.filter(item => String(item.u_id) === String(values.user.value));
        }
        if(values.status !== 'All') {
          filteredData = filteredData.filter(item => item.kyc_status === values.status);
        }

        if(filteredData.length > 0) {
          handleT1Body(filteredData);
        }
        else {
          let tempTBody = (<tr>
                          <td colSpan="7" className="text-center">No records found</td>
                        </tr>);

          setUsersTBody(tempTBody);
        }

        submit1.disabled = false;
        submit1.textContent = 'Search';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [KYCResponse, setKYCResponse] = React.useState('');
  const [StandardModal3, setStandardModal3] = React.useState(false);
  const togStandardModal3 = async (elementData) => {
    setKYCResponse(elementData.kyc_response);
    setStandardModal3(true);
  }

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async (elementData) => {
    validation2.setValues({
      ...validation2.values,
      u_id: elementData.u_id,
      status: elementData.kyc_status,
      kyc_comment: elementData.kyc_comment,
    });
    setStandardModal2(true);
  }

  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      u_id: '',
      status: '',
      kyc_comment: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit2');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          u_id: values.u_id,
          kyc_status: values.status,
          kyc_comment: values.kyc_comment
        });
        const res = await postRequest('update-user-kyc-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetUsers();
          setTimeout(() => {
            validation1.handleSubmit();
          }, 500);

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal2(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const [UsersData, setUsersData] = React.useState([]);
  const [UsersCustomData, setUsersCustomData] = React.useState([]);
  const [UsersTBody, setUsersTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{element.first_name}</td>
        <td>{element.last_name}</td>
        {element.kyc_status !== 'Pending' && element.kyc_status !== 'Cancelled'?
          <td>{element.kyc_identification_id}</td>
        : <td>-</td> }
        <td>{formatDate(element.created_at)}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.kyc_status === 'Pending' ? 'badge-soft-warning' : element.kyc_status === 'Approved' ? 'badge-soft-success' : 'badge-soft-secondary')}>{element.kyc_status}</span></td>
        <td>
          <div className="centerLink">
            <Link title="Edit KYC Status" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal2(element)}><i className="bx bx-cog"></i></Link>
            {element.kyc_status !== 'Pending' && element.kyc_status !== 'Cancelled'?
              <span title="View User KYC" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal3(element)} data-toggle="modal" data-target="#myModal"><i className="bx bx-show-alt"></i></span>
            : '' }
          </div>
        </td>
      </tr>
    ));

    setUsersTBody(tempTBody);
  }
  const handleLoadGetUsers = async () => {
    const res = await getRequest('get-users');
    if (res && res.code === 200) {
      let originalText = res.data;

      setUsersData(originalText);
      handleT1Body(originalText);

      let tempArr = [{label: 'All', value: 'All'}];
      originalText.forEach(element => {
        let temp = {
            label: `${element.first_name} ${element.last_name} (${element.email})`,
            value: element.u_id,
        };
        tempArr.push(temp);
      });
      if (props.match.params.id) {
        let getUser = tempArr.find(element => String(element.value) === String(atob(props.match.params.id)));
        
        validation1.setValues({
          ...validation1.values,
          user: getUser,
        });

        setTimeout(() => {
          validation1.handleSubmit();
        }, 500);
      }
      tempArr = [{
          options: tempArr
      }];
      setUsersCustomData(tempArr);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="7" className="text-center">No records found</td>
                      </tr>);

      setUsersTBody(tempTBody);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetUsers();
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Tokenizedgreen")} breadcrumbItem={props.t("Users KYC")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="row">
                      <Col md={4} xs={12}>
                        <div className="mb-3 Register-Select2">
                          <label className="form-label">Users : </label>
                          <Select styles={colourStyles} value={validation1.values.user} onChange={(e) => validation1.setValues({ ...validation1.values, user: e })} options={UsersCustomData} classNamePrefix="select2-selection" />
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label">Status : </label>
                          <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                            <option value={'All'}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Approved'}>Approved</option>
                            <option value={'Cancelled'}>Cancelled</option>
                          </select>
                        </div>
                      </Col>
                      <Col md={3} xs={12}>
                        <div className="mb-3">
                          <label className="form-label fullWidth">&nbsp; </label>
                          <Button type="button" 
                            id="submit1"
                            onClick={(e) => {
                              e.preventDefault();
                              validation1.handleSubmit();
                              return false;
                            }}
                          color="primary">Search</Button>
                        </div>
                      </Col>
                    </div>
                    <div className="table-responsive mb-0" data-pattern="priority-columns">
                      <table className="table table-hover table-highlight" style={{ minWidth: '1000px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Verification ID</th>
                            <th>Date </th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Change Status</h5>
              <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Status : </Label>
                  <select className="form-select" name="status" value={validation2.values.status} onChange={(e) => validation2.setValues({ ...validation2.values, status: e.target.value })}>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                  {validation2.touched.status && validation2.errors.status ? (
                    <FormFeedback type="invalid">{validation2.errors.status}</FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Comment : </Label>
                  <textarea
                    className="form-control"
                    name="kyc_comment"
                    placeholder={'Enter comment'}
                    onChange={validation2.handleChange}
                    value={validation2.values.kyc_comment || ""}
                  >
                  </textarea>
                </div>
              </Col>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary"
                id="submit2"
                onClick={(e) => {
                  e.preventDefault();
                  validation2.handleSubmit();
                  return false;
                }}
              > Update </button>
              <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)}>Close</button>
            </div>
          </Modal>

          <Modal className="transation modalLarge" centered backdrop="static" isOpen={StandardModal3}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">KYC API Responce</h5>
              <button type="button" onClick={(e)=>setStandardModal3(false)} className="close" data-dismiss="modal" aria-label="Close" >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Col md={12}>
                <pre>{KYCResponse}</pre>
              </Col>
            </div>
          </Modal>
        </Container>
      </div>

    </React.Fragment>
  );
};

export default withTranslation()(UserKYC);
